// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LegendeSurvol_container__4M3al {\n  padding: 1rem 1rem calc(1rem - 4px);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Legende/LegendeSurvol.module.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;AACrC","sourcesContent":[".container {\n  padding: 1rem 1rem calc(1rem - 4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "LegendeSurvol_container__4M3al"
};
export default ___CSS_LOADER_EXPORT___;
